import { Tooltip, Card, Button, Switch, Empty } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ConfirmationModal from "../../../../Modal/ConfirmationModal";
import SortingArrow from "../../../../Common/SortingArrow";
import SelectAssociateDropZone from "../../../../Modal/SelectAssociateDropZone";
import globalRequest from "../../../../utils/global/globalRequest";
import * as Apis from "../../../../utils/helper/enum";
import toast from "react-hot-toast";

const AssociateDropzone = () => {
  let { branchId } = useParams();
  const [itemData, setItemData] = useState(null);
  const [items, setItems] = useState([]);
  const [allDropZones, setAllDropZones] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const getAllBranchDropZones = async (id) => {
    try {
      let response = await globalRequest(
        Apis.MANAGE_VENDOR.BRANCH_DROPZONE_LIST + "/" + branchId,
        "get",
        {},
        {},
        true
      );
      let apiResponse = response?.data?.data;
      let dropZoneData = [];
      if (apiResponse?.data?.length > 0) {
        for (let item of apiResponse.data) {
          let dropZoneName = "";
          for (let row of item?.dropZone?.dropZoneLocales) {
            if (row.languageCode === "en") dropZoneName = row.name;
          }
          dropZoneData.push({
            id: item.id,
            branchId: item.branchId,
            dropZoneId: item.dropZoneId,
            name: dropZoneName,
            address: item?.dropZone?.address,
            discount: item?.dropZone?.discount,
            volume: item?.dropZone?.volume,
            status: item?.status,
          });
        }
        setItems(dropZoneData);
      } else setItems([]);
    } catch (e) {
      toast.error(e?.message);
    }
  };
  // useEffect(() => {
  //   getAllBranchDropZones(branchId);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const handleStatusChange = async (item) => {
    try {
      let value = { status: item.status === "active" ? "inactive" : "active" };
      let response = await globalRequest(
        Apis?.MANAGE_VENDOR?.UPDATE_BRANCH_DROPZONE_STATUS + "/" + item.id,
        "put",
        value,
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "DropZone active successfully";
        if (item.status === "active") msg = "DropZone inactive successfully";
        toast.success(msg, {
          duration: 2000,
        });
        getAllBranchDropZones(branchId);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  const getAllDropZones = async (id) => {
    try {
      let response = await globalRequest(
        Apis.MANAGE_VENDOR.DROPZONE_LIST,
        "get",
        {},
        {},
        true
      );
      let apiResponse = response?.data?.data;
      setAllDropZones(apiResponse?.data);
    } catch (e) {
      toast.error(e?.message);
    }
  };
  useEffect(() => {
    getAllBranchDropZones(branchId);
    getAllDropZones(branchId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isSelectAssociateDropZone, setIsSelectAssociateDropZone] =
    useState(false);

  const handleDeleteOk = async () => {
    setIsDeleteModalOpen(false);
    try {
      let value = {};
      let response = await globalRequest(
        Apis?.MANAGE_VENDOR?.DELETE_BRANCH_DROPZONE + "/" + itemData.id,
        "delete",
        value,
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Branch dropzone deleted successfully";
        toast.success(msg, {
          duration: 2000,
        });
        getAllBranchDropZones(branchId);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };
  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false);
  };
  const handleSelectAssociateDropZone = async (seletedIdes) => {
    setIsSelectAssociateDropZone(false);
    try {
      let value = {
        branch_id: branchId,
        seleted_ides: seletedIdes,
      };
      let response = await globalRequest(
        Apis?.MANAGE_VENDOR?.ASSOCIATE_DROPZONE_WITH_BRANCH,
        "post",
        value,
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Dropzone added successfully";
        toast.success(msg, {
          duration: 2000,
        });
        getAllBranchDropZones(branchId);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };
  const handleSelectAssociateDropZoneCancel = () => {
    setIsSelectAssociateDropZone(false);
  };
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sortedItems = [...items].sort((a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setItems(sortedItems);
  };

  return (
    <>
      <Card>
        <div className="flex justify-end	mb-4 gap-5">
          <Button
            type="primary"
            size={14}
            icon={<PlusOutlined />}
            className="mx-1.5 cursor-pointer"
            onClick={() => {
              setIsSelectAssociateDropZone(true);
            }}
          >
            Add Dropzone
          </Button>
        </div>
        <div className="relative overflow-x-auto">
          <table className="w-full  text-left	 text-sm  text-gray-500">
            <thead className=" text-gray-700 capitalize text-xs	 bg-gray-50">
              <tr>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Name (English){" "}
                  <SortingArrow onSort={() => handleSort("name")} />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Address <SortingArrow onSort={() => handleSort("address")} />
                </th>
                <th
                  scope="col"
                  className="px-3 py-3 whitespace-nowrap w-[110px]"
                >
                  Discount %{" "}
                  <SortingArrow onSort={() => handleSort("discount")} />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Volume <SortingArrow onSort={() => handleSort("volume")} />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Status
                </th>
                <th
                  scope="col"
                  className="px-3 py-3 text-center whitespace-nowrap vertical-top"
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {items?.length ? (
                items?.map((item, index) => (
                  <>
                    <tr className="bg-white border-b">
                      <td className="px-3 py-4 vertical-top whitespace-nowrap">
                        {item?.name}
                      </td>
                      <td className="px-3 py-4 vertical-top whitespace-nowrap">
                        {item?.address}
                      </td>
                      <td className="px-3 py-4 vertical-top">
                        {item?.discount}
                      </td>
                      <td className="px-3 py-4 vertical-top">{item?.volume}</td>
                      <td className="px-3 py-4 vertical-top">
                        <Switch
                          checked={item?.status === "active" ? true : false}
                          onChange={() => {
                            handleStatusChange(item);
                          }}
                        />
                      </td>
                      <td className="px-3 py-4 text-center whitespace-nowrap vertical-top">
                        {/* <Tooltip title="Edit">
                      <EditOutlined className="mx-1.5 cursor-pointer" />
                    </Tooltip> */}
                        <Tooltip title="Delete">
                          <DeleteOutlined
                            className="mx-1.5 cursor-pointer"
                            onClick={() => {
                              setIsDeleteModalOpen(true);
                              setItemData(item);
                            }}
                          />
                        </Tooltip>
                      </td>
                    </tr>
                  </>
                ))
              ) : (
                <tr>
                  <td colSpan={6} className="text-center mt-3">
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Card>
      {/* delete modal */}
      <ConfirmationModal
        ConfirmationHeading="Delete"
        ConfirmationParagraph="Are you sure you want to delete this Drop zone?"
        isOpen={isDeleteModalOpen}
        onOk={handleDeleteOk}
        onCancel={handleDeleteCancel}
      />
      {isSelectAssociateDropZone && (
        <SelectAssociateDropZone
          isOpen={isSelectAssociateDropZone}
          onOk={(seletedIdes) => {
            handleSelectAssociateDropZone(seletedIdes);
          }}
          onCancel={handleSelectAssociateDropZoneCancel}
          allDropZones={allDropZones}
          selectedItems={items}
        />
      )}
    </>
  );
};
export default AssociateDropzone;
